<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="12.5" y="5.5" width="7" height="7" rx="1.5" fill="var(--bg-color)" stroke="var(--icon-color)" />
<rect x="4.5" y="19.5" width="7" height="7" rx="1.5" fill="var(--bg-color)" stroke="var(--icon-color)" />
<rect x="20.5" y="19.5" width="7" height="7" rx="1.5" fill="var(--bg-color)" stroke="var(--icon-color)" />
<path d="M11 10H9C7.89543 10 7 10.8954 7 12V18" stroke="var(--icon-color)" />
<path d="M21 10H23C24.1046 10 25 10.8954 25 12V18" stroke="var(--icon-color)" />
<path d="M19 23L13 23" stroke="var(--icon-color)" />
</svg>
